import { useSelector } from 'react-redux';

import { Types } from '@store/types';

const initialState = {
	materialRequisition: {}
};

const MaterialRequisitionReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_MATERIAL_REQUISITION:
			return {
				...state,
				materialRequisition: action.payload
			};
		case Types.UPDATE_MATERIAL_REQUISITION:
			return {
				...state,
				materialRequisition: {
					...state.materialRequisition,
					data: [action.payload, ...state.materialRequisition.data]
				}
			};
		default:
			return { ...state };
	}
};

export const useMaterialRequisition = () =>
	useSelector((state) => state.materialRequisitionStore.materialRequisition);

export default MaterialRequisitionReducer;
